import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const PolitiqueConfidentialitePage = () => {
  useEffect(() => {
    document.title = "Politique de Confidentialité | Cocoonut Digital Strasbourg";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Politique de Confidentialité | Cocoonut Digital Strasbourg</title>
        <meta name="description" content="Politique de confidentialité et protection des données personnelles de Cocoonut Digital, conforme au RGPD." />
        <link rel="canonical" href={`${window.location.origin}/politique-de-confidentialite`} />
      </Helmet>
      {/* Header */}
      <div className="bg-[#1a3a52] py-8">
        <div className="container mx-auto px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors mb-4"
          >
            <ArrowLeft size={20} />
            <span>Retour à l'accueil</span>
          </Link>
          <h1 className="text-3xl md:text-4xl font-brand-display text-white">Politique de Confidentialité</h1>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          {/* Introduction */}
          <section className="mb-10">
            <p className="text-[#151515]/80 leading-relaxed">
              La protection de vos données personnelles est une priorité pour Cocoonut Concept Creations. Cette politique de confidentialité vous informe sur la manière dont vos données sont collectées, utilisées et protégées conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
          </section>

          {/* Données collectées */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Données collectées</h2>
            <p className="text-[#151515]/80 mb-4">
              Les données collectées via le formulaire de contact sont :
            </p>
            <ul className="list-disc list-inside text-[#151515]/80 space-y-2 ml-4">
              <li>Nom</li>
              <li>Email</li>
              <li>Nom de l'établissement (le cas échéant)</li>
              <li>Message</li>
            </ul>
          </section>

          {/* Utilisation des données */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Utilisation des données</h2>
            <p className="text-[#151515]/80">
              Ces données sont utilisées uniquement pour répondre aux demandes professionnelles et établir un contact commercial.
            </p>
          </section>

          {/* Partage des données */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Partage des données</h2>
            <p className="text-[#151515]/80">
              Vos données personnelles <strong>ne sont ni revendues ni transmises à des tiers</strong>.
            </p>
          </section>

          {/* Vos droits */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Vos droits</h2>
            <p className="text-[#151515]/80 mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside text-[#151515]/80 space-y-2 ml-4">
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit de suppression</li>
              <li>Droit à la portabilité</li>
              <li>Droit d'opposition</li>
            </ul>
            <p className="text-[#151515]/80 mt-4">
              Pour exercer ces droits, contactez-nous à :{' '}
              <a href="mailto:rhamgffry@cocoonutconcept.com" className="text-[#d4a574] hover:underline">
                rhamgffry@cocoonutconcept.com
              </a>
            </p>
          </section>

          {/* Durée de conservation */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Durée de conservation</h2>
            <p className="text-[#151515]/80">
              Les données sont conservées pour une durée maximale de <strong>3 ans</strong> après le dernier contact.
            </p>
          </section>

          {/* Cookies */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Cookies</h2>
            <p className="text-[#151515]/80">
              Ce site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie de tracking publicitaire n'est utilisé.
            </p>
          </section>

          {/* Contact */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-[#1a3a52] mb-4">Contact</h2>
            <div className="text-[#151515]/80">
              <p>Pour toute question relative à cette politique de confidentialité :</p>
              <p className="mt-2">
                <strong>Cocoonut Concept Creations</strong><br />
                8 rue du Commandant L'Herminier, 67640 Fegersheim, France<br />
                Email : <a href="mailto:rhamgffry@cocoonutconcept.com" className="text-[#d4a574] hover:underline">rhamgffry@cocoonutconcept.com</a>
              </p>
            </div>
          </section>

        </motion.div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialitePage;
